import { render, staticRenderFns } from "./PublishPatent.vue?vue&type=template&id=2005e460&scoped=true"
import script from "./PublishPatent.vue?vue&type=script&lang=js"
export * from "./PublishPatent.vue?vue&type=script&lang=js"
import style0 from "./PublishPatent.vue?vue&type=style&index=0&id=2005e460&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2005e460",
  null
  
)

export default component.exports